import { ProviderLabels } from './provider-labels';

export const labels: ProviderLabels = {
  provider: 'Braintree',
  environment: {
    live: 'Production',
    test: 'Sandbox',
  },
  coupon: {
    singular: 'Discount',
    plural: 'Discounts',
    id: 'ID',
  },
  dashboard: {
    login: 'https://www.braintreegateway.com/login',
  },
};
